import { render, staticRenderFns } from "./AllocationCalendar.vue?vue&type=template&id=137bb2ad"
import script from "./AllocationCalendar.vue?vue&type=script&lang=js"
export * from "./AllocationCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137bb2ad')) {
      api.createRecord('137bb2ad', component.options)
    } else {
      api.reload('137bb2ad', component.options)
    }
    module.hot.accept("./AllocationCalendar.vue?vue&type=template&id=137bb2ad", function () {
      api.rerender('137bb2ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/ambience/AllocationCalendar.vue"
export default component.exports